{
  "panel": {
    "title": "یادداشت‌ها",
    "newNote_title": "یادداشت جدید",
    "search_placeholder": "جستجوی یادداشت‌ها…",
    "search_aria": "جستجوی یادداشت‌ها",
    "clearSearch_aria": "پاک کردن جستجو",
    "editorPlaceholder": "چه در ذهن دارید…",
    "titleInput_placeholder": "بدون عنوان",
    "untitled": "بدون عنوان",
    "emptyNote": "یادداشت خالی",
    "loadingNotes": "در حال بارگذاری یادداشت‌ها…",
    "noNotesYet": "هنوز یادداشتی نیست. برای ساختن یکی روی + ضربه بزنید.",
    "noResults": "نتیجه‌ای برای «{{query}}» نیست",
    "noNotesTagged": "یادداشتی با برچسب {{tag}} نیست",
    "tagFilterAll": "همه",
    "filterByTag_aria": "فیلتر بر اساس برچسب",
    "templates": "قالب‌ها",
    "editorTheme_aria": "پوسته ویرایشگر",
    "themeActive_aria": "پوسته {{theme}} (فعال)",
    "theme_aria": "پوسته {{theme}}",
    "themeName": {
      "dark": "تیره",
      "sepia": "قهوه‌ای",
      "light": "روشن",
      "forest": "جنگلی"
    },
    "voice": "صدا",
    "voice_title": "یادداشت صوتی",
    "voiceUnavailable_title": "تشخیص گفتار در این مرورگر در دسترس نیست",
    "openVoiceRecorder_aria": "گشودن ضبط‌کننده یادداشت صوتی",
    "summarizing_title": "در حال خلاصه‌سازی…",
    "summarize_title": "خلاصه‌سازی",
    "summarizeNote_aria": "خلاصه‌سازی یادداشت",
    "aiCommands_title": "دستورهای هوش مصنوعی  Cmd+K",
    "openAiPalette_aria": "گشودن پالت دستور هوش مصنوعی",
    "enterFocusMode_title": "حالت تمرکز  Cmd+Shift+F",
    "exitFocusMode_title": "خروج از حالت تمرکز  Cmd+Shift+F",
    "enterFocusMode_aria": "ورود به حالت تمرکز",
    "exitFocusMode_aria": "خروج از حالت تمرکز",
    "export_title": "برون‌بری یادداشت",
    "delete_title": "حذف یادداشت",
    "delete_aria": "حذف یادداشت",
    "moreActions_title": "اقدامات بیشتر",
    "wordCount_one": "{{formatted}} واژه · ~{{minutes}} دقیقه مطالعه",
    "wordCount_other": "{{formatted}} واژه · ~{{minutes}} دقیقه مطالعه",
    "referencedBy_one": "ارجاع‌شده توسط {{count}}",
    "referencedBy_other": "ارجاع‌شده توسط {{count}}",
    "noMatchingNotes": "یادداشت مطابقی نیست",
    "mobileTabs_aria": "نمای یادداشت‌ها",
    "mobileTabNotes": "یادداشت‌ها",
    "mobileTabEditor": "ویرایشگر",
    "saveFailed": "ذخیره یادداشت ناموفق بود: {{message}}",
    "deleteFailed": "حذف یادداشت ناموفق بود",
    "loadFailed": "بارگذاری یادداشت‌ها ناموفق بود",
    "analyzeFailed": "تحلیل یادداشت ناموفق بود",
    "aiCommandFailed": "دستور هوش مصنوعی ناموفق بود",
    "unknownError": "خطای ناشناخته"
  },
  "paywall": {
    "title": "یادداشت‌ها بخشی از ریمن پرو است",
    "safariBody": "Unlock synced notes, dictation, and AI summaries with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "body": "یادداشت‌های همگام‌شده، دیکته مبتنی بر مرورگر و خلاصه‌های ساختاریافته هوش مصنوعی را بگشایید."
  },
  "format": {
    "bold": "ضخیم",
    "italic": "مورب",
    "strikethrough": "خط‌خورده",
    "inlineCode": "کد درون‌خطی",
    "heading1": "سرتیتر ۱",
    "heading2": "سرتیتر ۲",
    "heading3": "سرتیتر ۳",
    "bulletList": "فهرست نقطه‌ای",
    "numberedList": "فهرست شماره‌دار",
    "blockquote": "نقل‌قول",
    "codeBlock": "بلوک کد",
    "toggleBold_aria": "تغییر وضعیت ضخیم",
    "toggleItalic_aria": "تغییر وضعیت مورب",
    "toggleStrikethrough_aria": "تغییر وضعیت خط‌خورده",
    "toggleInlineCode_aria": "تغییر وضعیت کد درون‌خطی",
    "toggleBulletList_aria": "تغییر وضعیت فهرست نقطه‌ای",
    "toggleNumberedList_aria": "تغییر وضعیت فهرست شماره‌دار",
    "toggleBlockquote_aria": "تغییر وضعیت نقل‌قول",
    "formatOptions_aria": "گزینه‌های قالب‌بندی"
  },
  "analysis": {
    "heading": "خلاصه",
    "onDevice": "⚡ روی دستگاه",
    "onDevice_aria": "پردازش‌شده روی دستگاه",
    "applyToNote_title": "اعمال بر یادداشت",
    "applyToNote_aria": "اعمال خلاصه بر یادداشت",
    "summaryLabel": "خلاصه",
    "keyPointsLabel": "نکات کلیدی",
    "noKeyPoints": "نکته کلیدی‌ای برای این یادداشت بازگردانده نشد."
  },
  "export": {
    "markdown": "برون‌بری به‌صورت Markdown",
    "plainText": "برون‌بری به‌صورت متن ساده",
    "pdf": "برون‌بری به‌صورت PDF",
    "allZip": "برون‌بری همه به‌صورت ZIP",
    "label": "برون‌بری"
  },
  "cmdk": {
    "dialog_aria": "پالت دستور هوش مصنوعی",
    "input_placeholder": "از هوش مصنوعی بپرسید یا دستوری اجرا کنید…",
    "esc": "Esc",
    "back_aria": "بازگشت",
    "translateTo": "ترجمه به",
    "language_placeholder": "زبان…",
    "aiActions": "اقدامات هوش مصنوعی",
    "noCommandsMatch": "دستوری با «{{query}}» مطابقت ندارد",
    "continue": {
      "label": "ادامه نوشتن",
      "description": "از جایی که رها کردید ادامه دهید"
    },
    "summarize": {
      "label": "خلاصه‌سازی انتخاب",
      "description": "تلخیص به نکات کلیدی"
    },
    "formal": {
      "label": "این را رسمی کن",
      "description": "بالا بردن لحن به حالت حرفه‌ای"
    },
    "simplify": {
      "label": "ساده‌سازی",
      "description": "زبان کوتاه‌تر و روشن‌تر"
    },
    "translate": {
      "label": "ترجمه به…",
      "description": "ترجمه به زبانی دیگر"
    },
    "expand": {
      "label": "گسترش این نقطه",
      "description": "گسترش نقطه انتخاب‌شده به نثر"
    },
    "languages": {
      "Spanish": "اسپانیایی",
      "Arabic": "عربی",
      "French": "فرانسوی",
      "German": "آلمانی",
      "Japanese": "ژاپنی",
      "Portuguese": "پرتغالی"
    }
  },
  "templates": {
    "dialog_aria": "انتخاب قالب",
    "header": "یک قالب انتخاب کنید",
    "builtInLabel": "از پیش‌ساخته",
    "myTemplatesLabel": "قالب‌های من",
    "saveCurrent": "ذخیره یادداشت کنونی به‌عنوان قالب",
    "myTemplatesEmpty": "قالب‌های ذخیره‌شده شما اینجا نمایان می‌شوند",
    "useTemplate": "استفاده از قالب",
    "meeting": {
      "name": "یادداشت‌های جلسه",
      "description": "ثبت تصمیم‌ها و اقدامات",
      "structure": "حاضران / دستور جلسه / یادداشت‌ها / اقدامات"
    },
    "journal": {
      "name": "دفترچه روزانه",
      "description": "بر روز خود تأمل کنید",
      "structure": "سپاسگزاری / دستاوردهای امروز / یادداشت‌ها"
    },
    "book": {
      "name": "خلاصه کتاب",
      "description": "ثبت ایده‌های کلیدی یک کتاب",
      "structure": "ایده اصلی / نقل‌قول‌های کلیدی / آموخته‌ها"
    },
    "project": {
      "name": "شرح پروژه",
      "description": "ترسیم دامنه، اهداف و ذی‌نفعان",
      "structure": "هدف / دامنه / ریسک‌ها / زمان‌بندی"
    },
    "brainstorm": {
      "name": "طوفان فکری",
      "description": "ثبت آزاد ایده‌ها",
      "structure": "موضوع / ایده‌ها / گام‌های بعدی"
    },
    "weekly": {
      "name": "بازبینی هفتگی",
      "description": "بازبینی و برنامه‌ریزی هفته خود",
      "structure": "دستاوردها / دشواری‌ها / حوزه‌های تمرکز"
    }
  },
  "voice": {
    "dialog_aria": "ضبط‌کننده یادداشت صوتی",
    "cancel_aria": "لغو",
    "statusRecording": "در حال ضبط",
    "statusTranscribing": "در حال رونویسی…",
    "statusReview": "بازبینی",
    "skip": "رد کردن",
    "mark": "نشانه",
    "mark_title": "گذاشتن نشانگر زمانی",
    "captureMeeting": "ضبط جلسه",
    "captureMeeting_title": "همچنین صدای یک زبانه جلسه را ضبط کنید",
    "meeting": "جلسه",
    "meeting_title": "در حال ضبط زبانه جلسه",
    "markers_aria": "نشانگرهای زمانی",
    "listening": "در حال شنیدن…",
    "micDenied": "دسترسی به میکروفون خاموش است. آن را در تنظیمات مجاز کنید و دوباره امتحان کنید.",
    "captureFailed": "ضبط شروع نشد. کمی بعد دوباره امتحان کنید.",
    "tabPicker_aria": "یک زبانه جلسه برای ضبط انتخاب کنید",
    "captureFrom": "ضبط صدا از…",
    "noAudibleTab": "هیچ زبانه‌ای صدا پخش نمی‌کند. جلسه خود را باز کنید و مطمئن شوید کسی در حال صحبت است، سپس دوباره تلاش کنید.",
    "tabPickerCancel": "لغو",
    "tabTranscript": "رونوشت",
    "structuring": "در حال ساختاردهی…",
    "structuredNote": "یادداشت ساختاریافته",
    "structureFailed": "ایجاد یادداشت ساختاریافته ممکن نشد.",
    "retryStructure": "تلاش دوباره",
    "browserTranscript": "رونوشت مرورگر",
    "nothingCaptured": "چیزی ضبط نشد.",
    "buildingStructured": "در حال ساخت یادداشت ساختاریافته…",
    "cancel": "لغو",
    "stop": "توقف",
    "recordAgain": "ضبط دوباره",
    "saveToNote": "ذخیره در یادداشت",
    "statusMeeting": "جلسه",
    "captureStrip_aria": "در حال ضبط صدا از {{tab}}",
    "stopCapture": "توقف ضبط زبانه",
    "stopCapture_title": "ضبط زبانه را متوقف کن — میکروفون به ضبط ادامه می‌دهد",
    "stopsIn": "توقف تا {{time}}",
    "autoStopped": "ضبط در حد ۶۰ دقیقه متوقف شد.",
    "autoStoppedQuota": "ضبط متوقف شد — دقیقه‌های رونویسی این ماه مصرف شده است.",
    "captureLost": "زبانهٔ جلسه بسته شد. میکروفون شما همچنان ضبط می‌کند.",
    "tabSummary": "خلاصه",
    "noSpeakers": "گویندگان شناسایی نشدند",
    "speakerN": "گوینده {{number}}",
    "renameSpeaker_aria": "تغییر نام {{name}} — روی همهٔ خطوط او اعمال می‌شود",
    "renameSpeaker_input_aria": "نام گوینده",
    "turnTime_title": "گفته‌شده در {{time}}",
    "actionItemsTitle": "موارد اقدام",
    "actionsCount": "{{checked}} از {{total}}",
    "addToTasks_one": "افزودن {{count}} به وظایف",
    "addToTasks_other": "افزودن {{count}} به وظایف",
    "addToTasksZero": "افزودن به وظایف",
    "adding": "در حال افزودن…",
    "tasksAdded_one": "{{count}} وظیفه افزوده شد",
    "tasksAdded_other": "{{count}} وظیفه افزوده شد",
    "viewTasks": "مشاهده",
    "addFailed": "افزوده نشد — دوباره تلاش کنید.",
    "minutesLeft_one": "{{count}} دقیقه باقی مانده",
    "minutesLeft_other": "{{count}} دقیقه باقی مانده",
    "minutesLeftShort_one": "{{count}} دقیقه باقی مانده",
    "minutesLeftShort_other": "{{count}} دقیقه باقی مانده",
    "minutesLeft_title": "{{count}} دقیقهٔ رونویسی در این ماه باقی مانده است",
    "quotaExhausted": "دقیقه‌های جلسهٔ این ماه مصرف شده است. در {{date}} تازه می‌شوند.",
    "quotaUnknown": "دقایق باقی‌مانده نامشخص است — ضبط ممکن است به سقف ماهانه برسد",
    "meetingProRequired": "رونویسی جلسات بخشی از Pro است. رونوشت زندهٔ شما در زیر حفظ شده است.",
    "gateTitle": "ضبط جلسه",
    "gateBody": "زبانهٔ یک جلسه را همراه میکروفون ضبط کنید — با شناسایی گویندگان و استخراج موارد اقدام. همراه Pro ارائه می‌شود.",
    "gateLater": "الان نه",
    "gateCta": "مشاهدهٔ Pro",
    "roomOption": "بدون زبانه — صدای اتاق را ضبط کن",
    "roomHint": "تماسی روی بلندگو، یک برنامه مستقل، یا افراد حاضر در اتاق — هر چیزی که با صدای بلند می‌شنوید.",
    "roomHint_title": "اگر طرف مقابل در هدفون شماست، میکروفون صدایش را نمی‌شنود — از بلندگو استفاده کنید.",
    "recordRoom": "ضبط صدای اتاق",
    "recordRoom_title": "هر کسی را که میکروفون می‌شنود ضبط کنید — با شناسایی گویندگان",
    "roomStart": "شروع",
    "statusRoom": "اتاق",
    "roomStrip": "در حال ضبط صدای اتاق",
    "roomStrip_aria": "در حال ضبط صدای اتاق — هر کسی که میکروفون می‌شنود",
    "roomOff": "خاموش کردن",
    "roomOff_title": "حالت اتاق را خاموش کن — این به یک یادداشت صوتی معمولی تبدیل می‌شود",
    "roomRenameHint": "برای تغییر نام روی یک نام بزنید — یکی از این‌ها شما هستید.",
    "gateBodyRoom": "آنچه را اطرافتان گفته می‌شود ضبط کنید — با شناسایی گویندگان و استخراج موارد اقدام. همراه Pro ارائه می‌شود.",
    "roomHintDevice": "تماس‌های همین دستگاه قابل ضبط نیستند — iOS آن‌ها را خصوصی نگه می‌دارد. گوشی دیگری روی بلندگو، یا گفت‌وگویی در اتاق، مشکلی ندارد.",
    "autoStoppedSize": "ضبط در حد اندازه بارگذاری متوقف شد.",
    "tooLarge": "ضبط برای بارگذاری بیش از حد بزرگ بود، بنابراین رونویسی نشد.",
    "destTo": "به",
    "dest_aria": "افزودن به فهرست: {{name}}",
    "destMenu_aria": "یک فهرست انتخاب کنید",
    "destNewPending_aria": "فهرست جدید: {{name}}"
  },
  "meetingNotice": {
    "title": "جلسه‌ها، در یادداشت‌های شما",
    "body": "Rhemn اکنون می‌تواند زبانهٔ جلسه‌ای را که انتخاب می‌کنید ضبط کند — فقط هنگام ضبط یادداشت صوتی، و فقط زبانه‌ای که برمی‌گزینید.",
    "factPrivacy": "صدا برای ساخت رونوشت پردازش و سپس حذف می‌شود. ضبط‌ها هرگز ذخیره نمی‌شوند.",
    "factControl": "تا وقتی ضبط را نزنید و زبانه‌ای انتخاب نکنید، چیزی ضبط نمی‌شود.",
    "cta": "متوجه شدم",
    "privacyLink": "سیاست حریم خصوصی ما را بخوانید",
    "dialog_aria": "دربارهٔ مجوز جدید ضبط جلسه"
  }
}
